import { makeComparableFirmwareVersion } from '@shure/shared/models';

export function firmwareVersionComparator(a?: string, b?: string): number {
	return makeComparableFirmwareVersion(a ?? '0.0.0.0').localeCompare(makeComparableFirmwareVersion(b ?? '0.0.0.0'));
}
